//var appName = "MagicCasino";
//var appMode = "profile";
registerGlobal('appPrefix');
appPrefix = EmInfo.appName + "." + MODE + ".";

registerGlobal('statusElement');
statusElement = document.getElementById('status');
registerGlobal('progressElement');
progressElement = document.getElementById('progress');
registerGlobal('spinnerElement');
spinnerElement = document.getElementById('spinner');

registerGlobal('Module');
Module = {
    preRun: [],
    postRun: [],
    print: createPrintFunction(),
    printErr: createPrintFunction(),
    canvas: (function() {
        var canvas = document.getElementById('canvas');

        // As a default initial behavior, pop up an alert when webgl context is lost. To make your
        // application robust, you may want to override this behavior before shipping!
        // See http://www.khronos.org/registry/webgl/specs/latest/1.0/#5.15.2
        canvas.addEventListener("webglcontextlost", function(e) {
            alert('WebGL context lost. You will need to reload the page.');
            e.preventDefault();
        }, false);

        return canvas;
    })(),
    setStatus: function(text) {
        if (!Module.setStatus.last) Module.setStatus.last = {
            time: Date.now(),
            text: ''
        };
        if (text === Module.setStatus.text) return;
        var m = text.match(/([^(]+)\((\d+(\.\d+)?)\/(\d+)\)/);
        var now = Date.now();
        if (m && now - Date.now() < 30) return; // if this is a progress update, skip it if too soon
        if (m) {
            text = m[1];
            progressElement.value = parseInt(m[2]) * 100;
            progressElement.max = parseInt(m[4]) * 100;
            progressElement.hidden = false;
            spinnerElement.hidden = false;
        } else {
            progressElement.value = null;
            progressElement.max = null;
            progressElement.hidden = true;
            if (!text) spinnerElement.style.display = 'none';
        }
        statusElement.innerHTML = text;
    },
    totalDependencies: 0,
    monitorRunDependencies: function(left) {
        this.totalDependencies = Math.max(this.totalDependencies, left);
        Module.setStatus(left ? 'Preparing... (' + (this.totalDependencies - left) + '/' + this.totalDependencies + ')' : 'All downloads complete.');
    }
};
Module.setStatus('Downloading...');

// Default handling of onAbort isn't giving us callstack under most browser
// So, override it, retry abort, and throw proper exception at end
Module["onAbort"] = function(msg) {
    Module["onAbort"] = null;
    try { Module.abort(); } catch(x) {}
    throw new Error(msg || "");
}

window.onerror = function(event) {
    // TODO: do not warn on ok events like simulating an infinite loop or exitStatus
    Module.setStatus('Exception thrown, see JavaScript console');
    spinnerElement.style.display = 'none';
    Module.setStatus = function(text) {
        if (text) Module.printErr('[post-exception status] ' + text);
    };
};



//////////////////
// WEBPACK FOOTER
// /src/claw/sdk/src/claw/system/emscripten/Application.module.js
// module id = 19
// module chunks = 0